export interface BackoffOptions {
  baseMs?: number;
  maxMs?: number;
  jitter?: number;
}
export class Backoff {
  private attempt = 0;
  private readonly base: number;
  private readonly max: number;
  private readonly jitter: number;
  constructor(options: BackoffOptions = {}) {
    this.base = options.baseMs ?? 1000;
    this.max = options.maxMs ?? 30_000;
    this.jitter = options.jitter ?? 0.25;
  }
  get failures(): number {
    return this.attempt;
  }
  next(): number {
    const raw = this.base * 2 ** Math.min(this.attempt, 16);
    const capped = Math.min(raw, this.max);
    this.attempt += 1;
    if (this.jitter === 0) return capped;
    const delta = capped * this.jitter;
    return Math.round(capped - delta + Math.random() * delta * 2);
  }
  reset(): void {
    this.attempt = 0;
  }
}
